import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { DateWithTimezones, StatusHistoryOriginEnum } from '../../../../common/models/status-history-chain.model';
import { DISPLAY_DATE_FORMAT } from '../../../../common/constants/date-config';
import { LatestNotification } from '../../../../store/state/monitoring/models';
import { LocalDate } from '../../../../store';
import { DirectivesModule } from '../../../../common/directives/directives.module';
import { PipesModule } from '../../../../common/pipes/pipes.module';
import { DateWithTimezoneComponent } from '../../../timezone/date-with-timezone.component';
import { DateWithProfileAndLocalTimezoneComponent } from '../../../profile-and-local-date/date-with-profile-and-local-timezone.component';
import { TranslateModule } from '@ngx-translate/core';

export const StatusHistoryOriginDisplayMap: Record<StatusHistoryOriginEnum, string> = {
  [StatusHistoryOriginEnum.Iftsta]: 'IFTSTA',
  [StatusHistoryOriginEnum.Ml]: 'ML',
  [StatusHistoryOriginEnum.ShipsGo]: 'ShipsGo',
  [StatusHistoryOriginEnum.IftstaManual]: 'IFTSTA MANUAL',
  [StatusHistoryOriginEnum.ManualAdaptation]: 'Manual Adaptation',
  [StatusHistoryOriginEnum.SHIPPEO]: 'SHIPPEO',
  [StatusHistoryOriginEnum.ShippeoETA]: 'Shippeo ETA',
  [StatusHistoryOriginEnum.DriverApp]: 'Driver App',
  [StatusHistoryOriginEnum.GeoFence]: 'Geo Fence',
  [StatusHistoryOriginEnum.Dhl]: 'DHL',
  [StatusHistoryOriginEnum.Idle]: 'Idle',
};
@Component({
  selector: 'ui-monitoring-notifications',
  imports: [
    CommonModule,
    MatCardModule,
    DirectivesModule,
    PipesModule,
    DateWithTimezoneComponent,
    DateWithProfileAndLocalTimezoneComponent,
    TranslateModule,
  ],
  templateUrl: './monitoring-notifications.component.html',
  styleUrls: ['./monitoring-notifications.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MonitoringNotificationsComponent {
  protected readonly StatusHistoryOriginDisplayMap = StatusHistoryOriginDisplayMap;
  statusHistoryOriginEnum = StatusHistoryOriginEnum;
  @Input() notifications: LatestNotification[];
  @Input() isLocalDate = false;
  @Input() displayLocalAndProfileTime = false;
  dateFormat = DISPLAY_DATE_FORMAT;

  getLocalDate(notification: LatestNotification): LocalDate {
    return notification?.actualArrivalTime as LocalDate;
  }

  getDateWithTimezones(notification: LatestNotification): DateWithTimezones {
    return notification?.actualArrivalTime as DateWithTimezones;
  }
}
